<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex user-nav">
            <p
              class=" d-block border rounded user-name mb-0"
              style="padding: 3px; min-width: 70px; padding-left: 7px; padding-right: 7px; border-color: #beadfa !important; text-align: end;"
            >
              ฿ {{ credit }}
            </p>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/rizz.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span @click="loggedOut">ออกจากระบบ</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BAvatar
} from 'bootstrap-vue'

import { getUserData, isUserLoggedIn } from '../../auth/utils'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      user: null,
      credit: '...'
    }
  },
  methods: {
    loggedOut() {
      console.log('Logout')
      localStorage.removeItem('userData')
      this.$router.push('/')
    },
    async getCredit() {
      if (isUserLoggedIn()) {
        const resp = await this.$http.get('/member/credit')
        this.credit = resp.data.result.credit
      }
    }
  },
  async beforeMount() {
    await this.getCredit()
    this.user = getUserData()
  }
}
</script>
